import { useLocation, useNavigate } from "react-router-dom"; // Import useLocation and useNavigate hooks
import { scroller } from "react-scroll"; // Import Link from react-scroll
import "../styles/Navbar.css";
import LogoMobile from "../components/img/logo1.png";
import MenuIcon from "@mui/icons-material/Menu";
import { useEffect, useState } from "react";

const Navbar = () => {
  const [isToggled, setIsToggled] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 1279);

  const location = useLocation(); // Get the current location (URL)
  const navigate = useNavigate(); // Hook to navigate programmatically

  const handleChange = () => {
    setIsToggled(!isToggled);
  };

  const handleChangeOff = () => {
    setIsToggled(false);
  };

  const handleResize = () => {
    if (window.innerWidth > 1279) {
      setIsDesktop(true);
    } else {
      setIsDesktop(false);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize); // Clean up event listener
  }, []);

  // Function to handle navigation to the root if not already there
  const handleNavClick = (targetSection: string) => {
    // If the current route is not "/", navigate to "/"
    if (location.pathname !== "/") {
      navigate("/"); // Navigate to the home page
      // After navigation, scroll immediately to the target section with no delay
      setTimeout(() => {
        scroller.scrollTo(targetSection, {
          smooth: true,
          duration: 0, // No scrolling animation when navigating from a different route
          offset: -70, // Optional: adjust for sticky headers
        });
      }, 100); // Add a slight delay to ensure navigation is completed
    } else {
      // If already on "/", scroll with animation
      scroller.scrollTo(targetSection, {
        smooth: true,
        duration: 500, // Smooth scrolling animation
        offset: -70,
      });
    }

    // Close mobile menu if it is toggled
    if (isToggled) {
      handleChangeOff();
    }
  };

  // Render desktop navigation
  if (isDesktop) {
    return (
      <div className="navbar">
        <div className="navItems">
          <span className="homeButton">
            <span
              className="linkHome"
              onClick={() => handleNavClick("home")} // Call the handler with the section name
            >
              <img src={LogoMobile} alt="Logo" className="logo" />
              GudokVlad
            </span>
          </span>
          <div className="pages">
            <span className="navButton">
              <span className="link" onClick={() => handleNavClick("projects")}>
                Projects
              </span>
            </span>
            <span className="navButton">
              <span
                className="link"
                onClick={() => handleNavClick("experience")}
              >
                Experience
              </span>
            </span>
            <span className="navButton">
              <span
                className="link"
                onClick={() => handleNavClick("education")}
              >
                Education
              </span>
            </span>
            <span className="navButton">
              <span className="link" onClick={() => handleNavClick("contacts")}>
                Contacts
              </span>
            </span>
          </div>
        </div>
      </div>
    );
  } else {
    // Render mobile navigation
    return (
      <div className="mobileNavigation">
        <div className="mobileNavbar">
          <span
            className="mobileHomeButton"
            onClick={() => handleNavClick("home")}
          >
            <img src={LogoMobile} alt="Logo" className="mobileLogo" />
            GudokVlad
          </span>
          <div className="mobilePages">
            <MenuIcon className="hamburgerIcon" onClick={handleChange} />
          </div>
        </div>
        <div
          className={`hamburgerMenu ${isToggled ? "show" : ""}`}
          onClick={handleChange}
        >
          <span
            className="navButtonMobile"
            onClick={() => handleNavClick("projects")}
          >
            Projects
          </span>
          <span
            className="navButtonMobile"
            onClick={() => handleNavClick("experience")}
          >
            Experience
          </span>
          <span
            className="navButtonMobile"
            onClick={() => handleNavClick("education")}
          >
            Education
          </span>
          <span
            className="navButtonMobile"
            onClick={() => handleNavClick("contacts")}
          >
            Contacts
          </span>
        </div>
      </div>
    );
  }
};

export default Navbar;
